<template>
  <div>
    <billboard-viewport v-bind:locked="appData().canBuy">
    <div id="million-bit-billboard"
      v-on:click="clickBillboard"
      @mouseenter="onMouseEnter" 
      @mouseleave="onMouseLeave" 
      @mousemove="onMouseMove"
      class="billboard"
      v-bind:class="{'showTooltip': hovering}"
      >
      <canvas id="uploadedImg"></canvas>
      <img v-bind:src="s3ImgSrc" alt="The Million Bit Homepage billboard" usemap="#linkmap" @load="onBillboardLoaded" @error="onBillboardError" />
      <map name="linkmap">
        <area v-for="link in links" target="_blank" alt="" title="" shape="rect" v-bind:coords="link.c" v-bind:href="$safeUrl(link.u)">
      </map>
      <div id="billboard-tooltip" :ref="'tooltip'"></div>
      <div class="homepage-animated" v-if="showVideo">
        <video id="billboard-video" v-bind:src="s3VidSrc" autoplay muted controls></video>
      </div>
    </div>
    </billboard-viewport>
    <div class="btn-group m-3 honk-text">
      <button v-if="!showVideo" @click="playVideo" class="btn btn-lg btn-outline-light">ANIMATE</button>
      <button v-if="showVideo" @click="playVideo" class="btn btn-lg btn-outline-light">STOP 🛑</button>
      <button v-if="!inspectMode" @click="toggleInspect" class="btn btn-lg btn-outline-light">INSPECT</button>
      <button v-if="inspectMode" @click="toggleInspect" class="btn btn-lg btn-outline-light">LINKS 🔗</button>
      <button v-on:click="$router.push('/break')" class="btn btn-lg btn-outline-light">BREAK 🕹️</button>
    </div>
    <div v-if="inspectMode && !inspectTrx" class="inspect-hint">Select some pixels to inspect them</div>
    <div v-if="inspectTrx" id="plot-inspect">
      <div class="inspect-card">
        <router-link v-bind:to="'/plot/' + inspectTrx.tokenId" class="inspect-image-link">
          <img v-bind:src="'https://millionbithomepage.com/seq/'+inspectTrx.seq+'/token.jpeg'" />
        </router-link>
        <div class="inspect-details">
          <div class="inspect-header">
            <router-link v-bind:to="'/plot/' + inspectTrx.tokenId" class="inspect-title">Plot #{{ inspectTrx.tokenId }}</router-link>
            <span class="inspect-size">{{ inspectTrx.x2 - inspectTrx.x1 }}x{{ inspectTrx.y2 - inspectTrx.y1 }}px</span>
          </div>
          <a v-bind:href="$safeUrl(inspectTrx.url)" target="_blank" class="inspect-url">{{ inspectTrx.url }}</a>
          <div class="inspect-links" v-if="inspectTrx.profile">
            <a v-if="inspectTrx.profile.base_name" v-bind:href="'https://base.org/name/'+inspectTrx.profile.base_name.replace('.base.eth', '')" target="_blank" class="inspect-social" title="Base Name">
              <svg width="16" height="16" viewBox="0 0 111 111" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M54.921 110.034C85.359 110.034 110.034 85.402 110.034 55.017C110.034 24.6319 85.359 0 54.921 0C26.0432 0 2.35281 22.1714 0 50.3923H72.8467V59.6416H3.9565e-07C2.35281 87.8625 26.0432 110.034 54.921 110.034Z" fill="#0052FF"/>
              </svg>
            </a>
            <a v-if="inspectTrx.profile.website_url && inspectTrx.profile.website_url !== inspectTrx.url" v-bind:href="$safeUrl(inspectTrx.profile.website_url)" target="_blank" class="inspect-social" title="Website">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-link-45deg" viewBox="0 0 16 16">
                <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
              </svg>
            </a>
            <a v-if="inspectTrx.profile.x_username" v-bind:href="'https://x.com/'+inspectTrx.profile.x_username" target="_blank" class="inspect-social" title="X / Twitter">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
              </svg>
            </a>
            <a v-if="inspectTrx.profile.tg_url" v-bind:href="$safeUrl(inspectTrx.profile.tg_url)" target="_blank" class="inspect-social" title="Telegram">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telegram" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"/>
              </svg>
            </a>
            <a v-if="inspectTrx.profile.token_ca" v-bind:href="'https://dexscreener.com/base/'+inspectTrx.profile.token_ca" target="_blank" class="inspect-social" title="Token Chart">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-graph-up" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M0 0h1v15h15v1H0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07"/>
              </svg>
            </a>
            <a v-if="inspectTrx.profile.nft_ca" v-bind:href="'https://magiceden.us/collections/base/'+inspectTrx.profile.nft_ca" target="_blank" class="inspect-social" title="NFT Collection">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-images" viewBox="0 0 16 16">
                <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
                <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z"/>
              </svg>
            </a>
          </div>
          <router-link v-bind:to="'/plot/' + inspectTrx.tokenId" class="btn btn-dark btn-sm inspect-view-btn">View Plot Details</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*global axios*/
import utils from '../utils';
import BillboardViewport from './BillboardViewport';
const BASE_S3_BUCKET = process.env.BASE_S3_BUCKET;
const BASE_S3_BUCKET_TRX = process.env.BASE_S3_BUCKET_TRX;

export default {
  name: 'homepage',
  components: { BillboardViewport },
  data () {
    return {
      links: [],
      transactions: [],
      // links: [{c: '0,0,1,1', u: 'http://google.com'}],
      s3Base: BASE_S3_BUCKET,
      s3BaseTrx: BASE_S3_BUCKET_TRX,
      // Lossless WebP of the billboard (about half the JPEG); falls back to the JPEG.
      s3ImgSrc: utils.getTsPath('homepage.webp'),
      s3VidSrc: utils.getTsPath('homepage.mp4'), // BASE_S3_BUCKET+'homepage.jpeg?'+Date.now(),
      s3LinkMap: utils.getTsPath('link_map.json'), // BASE_S3_BUCKET+'link_map.json?'+Date.now(),
      s3TransactionsJson: utils.getTsPath('transactions.json'), // BASE_S3_BUCKET+'transactions.json?'+Date.now(),
      isBillboardLoaded: false,
      hovering: false, // To track whether the mouse is hovering over the image
      mouseX: 0,       // To store the X coordinate of the mouse
      mouseY: 0,        // To store the Y coordinate of the mouse
      tooltipTxt: '',
      showVideo: false,
      inspectMode: false,
      inspectTrx: null,
    };
  },
  inject: ['updateAppRoute', 'saveEvent', 'doUpload', 'appData'],
  methods: {
    playVideo: function() {
      this.showVideo = !this.showVideo;
    },
    toggleInspect: function() {
      this.inspectMode = !this.inspectMode;
      if (!this.inspectMode) {
        this.inspectTrx = null;
      }
    },
    onBillboardError: function() {
      // No WebP yet (CloudFront answers a missing key with index.html): use the JPEG.
      if (this.s3ImgSrc.indexOf('homepage.webp') !== -1) {
        this.s3ImgSrc = this.s3ImgSrc.replace('homepage.webp', 'homepage.jpeg');
      }
    },
    onBillboardLoaded: function() {
      if (!this.isBillboardLoaded) {
        // Only trigger once (since we may reload the image later)
        this.isBillboardLoaded = true;
        this.updateAppRoute('/');
      }
    },
    clickBillboard: function(e) {
      // console.log('clickBillboard', e, e.target, typeof e.target, e.target.coords);
      // Don't track dragging image
      if (this.showVideo) return;
      if (this.appData().canBuy) {
        return;
      }
      // const { offsetX, offsetY } = e;

      // Get the mouse coordinates relative to the image even on mobile where iphone is scrolled down the page
      const target = e.currentTarget || e.target;
      const rect = target.getBoundingClientRect();
      const clientX = e.clientX;
      const clientY = e.clientY;

      const offsetX = clientX - rect.left;
      const offsetY = clientY - rect.top;

      if (!this.inspectMode) {
        if (e.target && e.target.coords) {
          const link = this.getLinkFromCoords(offsetX, offsetY);
          if (link) {
            this.saveEvent('clickBillboard', {
              url: link.u,
              x: offsetX,
              y: offsetY,
            });
            utils.trackEvent('clickBillboard', {url: link.u});
            utils.trackEvent('clickBillboard:'+link.u);
          }
        } else {
          utils.trackEvent('clickBillboard:emptySpace');
          if (!this.appData().isMobileOrTouch) {
            // Don't do this on mobile
            this.doUpload(offsetX, offsetY);
          }
        }
      } else {
        e.preventDefault();
        const trx = this.getTrxFromCoords(offsetX, offsetY);
        if (trx) {
          this.inspectTrx = trx;

          // Scroll to plot-inspect
          const plotInspect = document.getElementById('plot-inspect');
          if (plotInspect) {
            plotInspect.scrollIntoView({ behavior: 'smooth' });
          }
          this.saveEvent('clickBillboardInspect', {
            tokenId: trx.tokenId,
            x: offsetX,
            y: offsetY,
          });
        }
      }
    },
    onMouseEnter() {
      if (this.showVideo) return;
      this.hovering = true;
    },
    onMouseLeave() {
      this.hovering = false;
    },
    onMouseMove(e) {
      if (this.showVideo) return;
      if (this.appData().isMobileOrTouch) {
        return;
      }
      if (this.appData().canBuy) {
        this.hovering = false;
        return;
      }
      // Get the mouse coordinates relative to the image. Measure the billboard
      // (currentTarget), not e.target: over a plot e.target is its <area>, and
      // Safari gives an <area> an empty rect at (0,0) and page-relative offsetX/Y.
      const rect = e.currentTarget.getBoundingClientRect();
      this.mouseX = e.clientX - rect.left;
      this.mouseY = e.clientY - rect.top;
      // console.log(`Mouse move: ${this.mouseX}, ${this.mouseY}`, e.target.coords);
      if (!this.inspectMode) {
        if (e.target && e.target.coords) {
          const offsetX = this.mouseX;
          const offsetY = this.mouseY;
          const link = this.getLinkFromCoords(offsetX, offsetY);
          if (link && link.u) {
            const [x1, y1, x2, y2] = link.c.split(',');
            // console.log(`Mouse over link: ${link.u}`, link, x1, y1, x2, y2);
            this.$refs.tooltip.textContent = link.u;
          }
        } else {
          // console.log('Mouse over blank space');
          this.$refs.tooltip.textContent = 'Claim this space';
        }
        this.$refs.tooltip.style.left = `${this.mouseX}px`;
        this.$refs.tooltip.style.top = `${this.mouseY-50}px`;
        this.$refs.tooltip.style.marginLeft = `-${this.$refs.tooltip.offsetWidth/2}px`;
      } else {
        if (e.target && e.target.coords) {
          const offsetX = this.mouseX;
          const offsetY = this.mouseY;
          const trx = this.getTrxFromCoords(offsetX, offsetY);
          if (trx) {
            this.$refs.tooltip.textContent = `Plot ${trx.tokenId}`;
          } else {
            this.$refs.tooltip.textContent = 'Claim this space';
          }
        }
        this.$refs.tooltip.style.left = `${this.mouseX}px`;
        this.$refs.tooltip.style.top = `${this.mouseY-50}px`;
        this.$refs.tooltip.style.marginLeft = `-${this.$refs.tooltip.offsetWidth/2}px`;
      }
    },
    getTrxFromCoords: function(x, y) {
      for (let i = 0; i < this.transactions.length; i++) {
        const t = this.transactions[i];
        if (t.x1 <= x && t.x2 >= x && t.y1 <= y && t.y2 >= y) {
          return t;
        }
      }
    },
    getLinkFromCoords: function(x, y) {
      const links = this.links;
      for (let i = 0; i < links.length; i++) {
        const link = links[i];
        const [x1, y1, x2, y2] = link.c.split(',');
        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          return link;
        }
      }
      return null;
    },
    toastTransaction: function(t) {
      utils.toast({
        title: `${t.pixels} pixels sold!`,
        message: `To ${utils.escapeHtml(utils.truncateString(t.from))}<br />${utils.escapeHtml(t.url)}`,
        img: this.s3BaseTrx+t.hash+'-crop.jpeg',
        type: "success",
        duration: 10000
      });
      utils.trackEvent('toastTransaction');
    },
    toastTransactions: function () {
      try {
        const recentTransactions = this.transactions.slice(0, 5);
        if (!window.toastInterval) {
        window.toastInterval = setInterval(() => {
          if (recentTransactions.length > 0) {
            const t = recentTransactions.shift();
            const trxKey = 'toastedTrx-'+t.hash;
            if (localStorage.getItem(trxKey)) {
              return;
            }
            localStorage.setItem(trxKey, true);
            this.toastTransaction(t);
          }
        }, 30000);
        }
      } catch (e) {
        console.error('toastTransactions', e);
      }
    },
    fetchData: async function(doReload) {
      var self = this;
      if (doReload) {
        this.s3ImgSrc = utils.getFreshPath('homepage.webp');
      }
      return new Promise((resolve, reject) => {
        axios.get(self.s3LinkMap)
          .then((response) => {
            window.linkMap = self.links = response.data;
            axios.get(self.s3TransactionsJson)
              .then((response) => {
                self.transactions = response.data;
                self.toastTransactions();
                resolve();
              });
          })
          .catch(function (error) {
            console.log('Error loading '+self.s3LinkMap, error);
            reject(error);
          });
      });
    },
  },
  created: function () {
    this.fetchData();
  },
  mounted: function () {
    // Do popup on first visit
    const DID_SEE_WELCOME_SCREEN_KEY = 'DID_SEE_WELCOME_SCREEN';
    if (!localStorage.getItem(DID_SEE_WELCOME_SCREEN_KEY)) {
      setTimeout(() => {
        localStorage.setItem(DID_SEE_WELCOME_SCREEN_KEY, true);
        this.$bvModal.show('modal-intro');
      }, 5000);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.homepage-animated {
  position: absolute;
  top: 0;
}
  #uploadedImg {
    position: absolute;
    display: none;
  }
  .billboard {
    width: 1024px;
    height: 1024px;
    margin: 33px auto;
  }
  @media (max-width: 1055px) and (pointer: coarse) {
    .billboard {
      margin: 0;
    }
  }
  .billboard img {
    box-shadow: 0px 0px 100px #333333;
    image-rendering: pixelated;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }
  .billboard.showTooltip {
    cursor: pointer;
  }
  #billboard-tooltip {
    position: absolute;
    display: none;
    background: #000;
    color: #fff;
    padding: 5px;
    border-radius: 5px;
    z-index: 1000;
    max-height: 2em;
    overflow: hidden;
  }
  .billboard.showTooltip #billboard-tooltip {
    display: block;
  }
  .inspect-hint {
    color: #fff;
    padding: 12px;
    font-size: 14px;
    opacity: 0.8;
  }
  #plot-inspect {
    max-width: 480px;
    margin: 16px auto;
  }
  .inspect-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    align-items: stretch;
    box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  }
  .inspect-image-link {
    flex-shrink: 0;
    display: block;
    width: 120px;
    background: #f0f0f0;
  }
  .inspect-image-link img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    image-rendering: pixelated;
  }
  .inspect-image-link:hover {
    opacity: 0.85;
  }
  .inspect-details {
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    flex: 1;
  }
  .inspect-header {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 4px;
  }
  .inspect-title {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-decoration: none;
  }
  .inspect-title:hover {
    text-decoration: underline;
  }
  .inspect-size {
    font-size: 12px;
    color: #888;
  }
  .inspect-url {
    font-size: 13px;
    color: #0052FF;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    margin-bottom: 8px;
    text-align: left;
  }
  .inspect-url:hover {
    text-decoration: underline;
  }
  .inspect-links {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
  }
  .inspect-social {
    color: #555;
    transition: color 0.15s;
  }
  .inspect-social:hover {
    color: #000;
  }
  .inspect-view-btn {
    align-self: flex-start;
  }
</style>
